<template>
<div></div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      
    }
  },
  created(){
    let id=this.$route.query.id
    if(id){
        window.location.href="https://hq-mobile.91assets.com/#/assetInfo?id="+id
    }else{
        this.$router.push('/')
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/assetInfo.vue